import MetricCard from "@/components/MetricCard";
import MetricsGrid from "@/components/MetricsGrid";
import { useStudentsCountQuery } from "@/hooks/api/student.queries";
import { useAlumniCountQuery } from "@/hooks/api/alumni.queries";
import {
  BookOpen,
  Briefcase,
  GraduationCap,
  DollarSign,
  Users,
  Star,
  BarChart2,
  Building2,
} from "lucide-react";

const metrics = [
  {
    title: "Total Students",
    value: "0",
    iconRight: (
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-blue-100 text-blue-500">
        <GraduationCap size={18} />
      </span>
    ),
    trend: {
      icon: "↗",
      value: "0%",
      color: "green",
    },
    valueDescription: "Active enrolled students",
    testId: "metric-total-students",
  },
  {
    title: "Active Internships",
    value: "0",
    iconRight: (
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-purple-100 text-purple-500">
        <Briefcase size={18} />
      </span>
    ),
    trend: {
      icon: "↗",
      value: "0%",
      color: "green",
    },
    valueDescription: "Ongoing internships",
    testId: "metric-active-internships",
  },
  {
    title: "Placements (2025)",
    value: "0",
    iconRight: (
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-pink-100 text-pink-500">
        <Star size={18} />
      </span>
    ),
    trend: {
      icon: "↗",
      value: "0%",
      color: "green",
    },
    valueDescription: "89% placement rate",
    testId: "metric-placements",
  },
  {
    title: "Avg Stipend",
    value: "0",
    iconRight: (
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-yellow-100 text-yellow-500">
        <DollarSign size={18} />
      </span>
    ),
    trend: {
      icon: "↗",
      value: "0%",
      color: "green",
    },
    valueDescription: "Average internship stipend",
    testId: "metric-avg-package",
  },
  {
    title: "Training Programs",
    value: "",
    iconRight: (
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-blue-100 text-blue-500">
        <BookOpen size={18} />
      </span>
    ),
    valueDescription: "Coming soon",
    testId: "metric-training-programs",
  },
  {
    title: "Alumni Network",
    value: "0",
    iconRight: (
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-pink-100 text-pink-500">
        <Users size={18} />
      </span>
    ),
    trend: {
      icon: "↗",
      value: "0",
      color: "green",
    },
    valueDescription: "Total alumni",
    testId: "metric-alumni-network",
  },
  {
    title: "Avg CGPA",
    value: "",
    iconRight: (
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-teal-100 text-teal-500">
        <BarChart2 size={18} />
      </span>
    ),
    valueDescription: "Coming soon",
    testId: "metric-avg-cgpa",
  },
  {
    title: "Vendor Partners",
    value: "0",
    iconRight: (
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-orange-100 text-orange-500">
        <Building2 size={18} />
      </span>
    ),
    trend: {
      icon: "↗",
      value: "0",
      color: "green",
    },
    valueDescription: "Active partnerships",
    testId: "metric-vendor-partners",
  },
];

const Dashboard = () => {
  // Real counts (metrics without a backend yet stay at their default 0).
  const { data: totalStudents = 0 } = useStudentsCountQuery();
  const { data: totalAlumni = 0 } = useAlumniCountQuery();

  const liveMetrics = metrics.map((metric) => {
    if (metric.testId === "metric-total-students")
      return { ...metric, value: String(totalStudents) };
    if (metric.testId === "metric-alumni-network")
      return { ...metric, value: String(totalAlumni) };
    return metric;
  });

  return (
    <div className="flex flex-col gap-6 p-6">
      {/* Page Header */}
      <div>
        <h1 className="text-2xl font-bold">Dashboard</h1>
        <p className="text-muted-foreground text-sm">
          Comprehensive overview of internship &amp; placement management
        </p>
      </div>

      {/* Metrics Grid — 4 columns, equal card sizes */}
      <MetricsGrid>
        {liveMetrics.map((metric) => (
          <MetricCard
            key={metric.testId}
            title={metric.title}
            value={metric.value}
            iconRight={metric.iconRight}
            trend={metric.trend}
            valueDescription={metric.valueDescription}
            testId={metric.testId}
          />
        ))}
      </MetricsGrid>
    </div>
  );
};

export default Dashboard;
